import i18n from 'i18n'
import * as React from "react"
import { getSubmit, isEmpty } from "ui-seeker/utils"
import { SelectSeeker, IconSeekers, useUser } from "ui-seeker/core"

import { FORM_URL } from 'app/@common/constants'
import { getAppUserData } from "app/@utils"
import AppUserRoleIcon from 'app/@components/UserRoleIcon'


export default function SelectUser({ ...props }) {

    const { userData } = useUser()
    const appUserData = getAppUserData()
    const mainHotelsSectionsData = appUserData.mainHotelsSectionData

    const handleChange = (value, hotel) => {
        getSubmit(FORM_URL.SET_USERS_SLAVE, { uidSlave: value || '' }).then(() => {
            localStorage.setItem("uidSlave", value)
            localStorage.removeItem('dashboardSettings')
            localStorage.removeItem('packagesAllHotelsMode')
            localStorage.removeItem('packagesLastMainHotel')
            if (props.mainSection && hotel) {
                getSubmit(FORM_URL.SET_HOTEL, { idHotel: hotel }).finally(() => {
                    localStorage.setItem('selectedMainHotel', String(hotel))
                    window.location.reload()
                })
            } else {
                localStorage.removeItem('selectedMainHotel')
                window.location.reload()
            }
        })
    }

    const optionsData = JSON.parse(localStorage.getItem('selectorFeaturesData'))[props?.feature || 'all'] || []
    const options = [...optionsData]
    options.unshift({ value: parseInt(userData.userID), label: appUserData.username })

    const myProps = {
        options: options,
        placeholder: i18n.t('common:filters.user'),
        formatOptionLabel: ({ label, value }) => <>
            <abbr className="user-content" style={{ marginRight: '5px', display: 'inline' }}>
                <AppUserRoleIcon />
            </abbr> 
            <abbr style={{ display: 'inline-block', verticalAlign: 'middle' }}>{`${label?.length > 23 ? label.substring(0, 23) + '...' : label}`}</abbr>
        </>,
        ...props,
        value: props.value,
        onChange: e => {
            props.onChange(e.value)
            handleChange(e.value, !!mainHotelsSectionsData[e.value] && !isEmpty(mainHotelsSectionsData[e.value][props.type]) ? mainHotelsSectionsData[e.value][props.type]?.idHotel[0] : null)
        }
    }

    return <SelectSeeker {...myProps} />
}